import { render, staticRenderFns } from "./KidjoHeader.vue?vue&type=template&id=82bf1c1e&scoped=true"
import script from "./KidjoHeader.vue?vue&type=script&lang=js"
export * from "./KidjoHeader.vue?vue&type=script&lang=js"
import style0 from "./KidjoHeader.vue?vue&type=style&index=0&id=82bf1c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bf1c1e",
  null
  
)

export default component.exports